import { TabModule } from '../../../utils/constants/commonConstants';

export const MOBILE_SECTION_IDS = [TabModule.OVERVIEW, TabModule.MANAGEMENT_PROFILE, TabModule.AUDITED_FINANCIALS] as const;

export const isMobileSectionId = (id: string): id is (typeof MOBILE_SECTION_IDS)[number] =>
    (MOBILE_SECTION_IDS as readonly string[]).includes(id);

export const MOBILE_ASK_AICA_DELETE_HEADING = 'Delete';

export const MOBILE_ASK_AICA_DELETE_MESSAGE = 'Are you sure you want to permanently delete this chat?';

export const MOBILE_ASK_AICA_OPEN_CONVERSATIONS_LABEL = 'Open conversations';
